var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavBtnAudioOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.35 3.51004V15.4137H14.025V3.51004H16.35ZM6.975 3.51004V15.4137H4.65V3.51004H6.975ZM2.325 7.09639V11.8273H0V7.09639H2.325ZM21 7.09639V11.8273H18.675V7.09639H21ZM11.7 0V19H9.375V0H11.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBtnAudioOn);
export default __webpack_public_path__ + "static/media/nav_btn_audio_on.dd60fd1ebfed69a8df4ea161fca35968.svg";
export { ForwardRef as ReactComponent };